import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var AdjustmentLevelsReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default AdjustmentLevelsReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/AdjustmentLevels/AdjustmentLevelsReduxProps.ts
// module id = 315
// module chunks = 0